<ll-titulo></ll-titulo>

<planificacion-admin [planificacionId]="planificacionId" [enableReporte]="enableReporte"></planificacion-admin>
